import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _delay from 'lodash/delay';
import PropTypes from 'prop-types';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import mDevice from 'models/device';
// Custom
import {
  getDevicesList, sendCmdDevice, deleteDevice, getCompanies, refreshList,
} from 'actions';
import { fullListShape, deleteShape } from 'constants/PropTypesShapes';
import { navigateToShow, activatePath } from 'devices/navigation';
import { computeErrors } from 'utils/Forms';
import MainListTemplate from 'components/templates/MainListTemplate';
import { ActivateSimcardsContainedButton } from 'components/buttons/ContainedButtons';
import withPermissions from 'hocs/WithPermissions';
import withConfirmDialog from 'hocs/WithConfirmDialog';
import withLoading from 'hocs/WithLoading';
import withStateReinit from 'hocs/WithStateReinit';
import withTitle from 'hocs/WithTitle';
import DeviceFilters from 'devices/assets/main/DeviceFilters';
import DeviceRow from 'devices/assets/main/DeviceRow';

class DevicesList extends React.Component {
  constructor(props) {
    super(props);

    this.handleSendCmdDevice = this.handleSendCmdDevice.bind(this);
    this.handleDeleteDevice = this.handleDeleteDevice.bind(this);
    this.handleRowDbleClick = this.handleRowDbleClick.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);
  }

  componentDidMount() {
    const { hasPermission, handleGetCompanies } = this.props;

    if (hasPermission({ needed: permissions.pAdmin })) {
      handleGetCompanies();
    }
  }

  componentDidUpdate(prevProps) {
    const { deviceDelete, handleRefreshList } = this.props;
    // Operations catching
    if (!prevProps.deviceDelete.deleted && deviceDelete.deleted) {
      handleRefreshList();
    }
  }

  // Handlers
  handleSendCmdDevice(device, cmd) {
    const { handleDisplayConfirm, handleSendCmdDevice } = this.props;
    handleDisplayConfirm(
      { id: 'confirm.sendCmdDevice', values: { cmd } },
      () => handleSendCmdDevice(device.id, mDevice.minimize(device), cmd),
      {
        confirmLabel: 'send',
        additionalMessage: cmd === 'reset' && (
          <strong>
            <LocalizedMessage id="info.sendCmdResetDevice" />
          </strong>
        ),
      },
    );
  }

  handleDeleteDevice(device) {
    const { handleDisplayConfirm, handleDeleteDevice } = this.props;
    handleDisplayConfirm({ id: 'confirm.deleteDevice', values: { deviceSerial: device.serial } }, () => handleDeleteDevice(device.id));
  }

  handleRowDbleClick(device) {
    const { handleStartLoading } = this.props;
    if (device) {
      // Display loader and display device
      handleStartLoading();
      _delay(() => navigateToShow(device.id), 500);
    }
  }

  // Private
  doGetRowComp(props) {
    return <DeviceRow {...props} onDelete={this.handleDeleteDevice} />;
  }

  render() {
    const { devices, deviceDelete, handleGetDevicesList } = this.props;

    // Compute errors
    const errors = computeErrors(null, deviceDelete.error);

    // Permissions
    const { pAdmin } = permissions;

    return (
      <MainListTemplate
        title={<LocalizedMessage id="title.devicesList" />}
        icon={mDevice.icon}
        displayRefresh
        actionButtons={[
          <OnlyWith
            key="activate"
            permissions={{
              needed: pAdmin,
            }}
          >
            <ActivateSimcardsContainedButton primary path={activatePath()} />
          </OnlyWith>,
        ]}
        name={mDevice.name}
        listFeatures={mDevice.listFeatures()}
        errors={errors}
        withActions
        nbActions={2}
        elementsData={{
          loading: devices.loading,
          elements: devices.elements,
          handleGetList: handleGetDevicesList,
        }}
        onRowDbleClick={this.handleRowDbleClick}
        filtersComp={<DeviceFilters />}
        rowComp={this.doGetRowComp}
      />
    );
  }
}

DevicesList.propTypes = {
  devices: fullListShape.isRequired,
  deviceDelete: deleteShape.isRequired,
  handleRefreshList: PropTypes.func.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
  handleGetDevicesList: PropTypes.func.isRequired,
  handleSendCmdDevice: PropTypes.func.isRequired,
  handleDeleteDevice: PropTypes.func.isRequired,
  handleGetCompanies: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  devices: state.device.list,
  deviceDelete: state.device.delete,
});

const mapDispatchToProps = (dispatch) => ({
  handleRefreshList: () => {
    dispatch(refreshList());
  },
  handleGetDevicesList: (pagination, sort, filters) => {
    dispatch(getDevicesList(pagination, sort, filters));
  },
  handleSendCmdDevice: (id, device, cmd) => {
    dispatch(sendCmdDevice(id, device, cmd));
  },
  handleDeleteDevice: (id) => {
    dispatch(deleteDevice(id));
  },
  handleGetCompanies: () => {
    dispatch(getCompanies());
  },
});

module.exports = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withPermissions,
  withConfirmDialog,
  withLoading,
  withStateReinit(['deleteDevice']),
  withTitle('pageTitle.devices'),
)(DevicesList);



// WEBPACK FOOTER //
// ./routes/app/routes/devices/routes/list/components/DevicesList.js